import React, { Component } from "react";
import { connect } from "react-redux";
import { getMemberBettingHistory, getBettingHistoryFilterData, setMemberShowLocalState, setMemberShowInitialLoading } from "../../../store/ducks/member/actions";
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import { withNamespaces } from "react-i18next";
import Swal from "sweetalert2";
import moment from "moment";
import MemberBettingHistoryListing from "./MemberBettingHistoryListing";
import { filterErrorHandler } from "../../../hoc/Shared/utility";

const initialInputState = {
    start_date: moment().format('yyyy/MM/DD')+" 12:00:00 AM",
    end_date: moment().format('yyyy/MM/DD')+" 11:59:59 PM",
    transaction_date: moment().format('yyyy/MM/DD')+" 12:00:00 AM - "+moment().format('yyyy/MM/DD')+" 11:59:59 PM",
    category: "",
    vendor: "",
    ref_id: "",
    bet_no: "",
    game_title: ""
};

class MemberBettingHistory extends Component {
    constructor(props) {
        super(props);

        const initLoad = this.props.memberShowInitialLoading.filter(item => item.id === "betting_history");
        const initialLoading = initLoad[0].loading;

        if (initialLoading) {
            this.state = {
                currentPage: "betting_history",
                pageShow: "member_betting_listing",
                loading: true,
                reload: false,
                show_id: null,
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                order: "",
                totalRecords: 0,
                searchValue: "",
                filter: initialInputState,
                data: [],
                dropDown: {
                    gameType: [],
                    gameVendor: [],
                },
                subTotalBetAmt: 0,
                subTotalPayoutAmt: 0,
                subTotalWinLoseAmt: 0,
                subTotalTurnoverAmt: 0,
                totalBetAmt: 0,
                totalPayoutAmt: 0,
                totalWinLoseAmt: 0,
                totalTurnoverAmt: 0
            };
            this.props.setMemberShowLocalState(this.state);
        } else {
            this.state = this.props.memberBettingHistoryLocalState;
        }

        this.onInputChange = this.onInputChange.bind(this);
        // console.log("[MemberBettingHistory] constructor()", "\nprops: ",props, "\nstate: ", this.state);
    }

    componentDidMount() {
        // console.log("[MemberBettingHistory] componentDidMount()", "\nstate: ", this.state);
        const initLoad = this.props.memberShowInitialLoading.filter(item => item.id === "betting_history");
        const initialLoading = initLoad[0].loading;

        if (initialLoading) {
            const listingArr = this.getFilterArray();
            this.props.getMemberBettingHistory(listingArr);
            this.props.getBettingHistoryFilterData();

            this.props.setMemberShowInitialLoading(this.state.currentPage);
        } else {
            if (this.props.memberBettingHistoryData !== undefined) {
                if (this.props.memberBettingHistoryData.data && this.props.memberBettingHistoryData.data.data 
                    && this.props.memberBettingHistoryData.data.data.length > 0 
                    && Number(this.props.memberShowId) !== Number(this.props.memberBettingHistoryData.data.data.memberId)) {
                    const listingArr = this.getFilterArray();
                    this.props.getMemberBettingHistory(listingArr);
                    this.props.getBettingHistoryFilterData();
                } else {
                    this.setState({
                        loading: false,
                        reload: true,
                    });
                }
            } else {
                const listingArr = this.getFilterArray();
                this.props.getMemberBettingHistory(listingArr);
                this.props.getBettingHistoryFilterData();
            }
        }
    }
    
    shouldComponentUpdate(nextProps, nextState) {
        // console.log("[MemberBettingHistory] shouldComponentUpdate()", "\nnextProps: ",nextProps, "\nnextState: ",nextState);
        if (nextProps.memberShowId !== undefined && nextProps.memberBettingHistoryData !== undefined) {
            if(nextProps.memberBettingHistoryData !== this.props.memberBettingHistoryData) {
                if (nextProps.memberBettingHistoryData.data.responseCode === 200 && nextProps.memberBettingHistoryData.data.msgType === "success") {
                    Swal.close();
                    this.setState({
                        show_id: nextProps.memberShowId,
                        data: nextProps.memberBettingHistoryData.data.data.bettingHistory.row,
                        subTotalBetAmt: nextProps.memberBettingHistoryData.data.data.bettingHistory.subTotalBetAmt,
                        subTotalPayoutAmt: nextProps.memberBettingHistoryData.data.data.bettingHistory.subTotalPayoutAmt,
                        subTotalWinLoseAmt: nextProps.memberBettingHistoryData.data.data.bettingHistory.subTotalWinLoseAmt,
                        subTotalTurnoverAmt: nextProps.memberBettingHistoryData.data.data.bettingHistory.subTotalTurnoverAmt,
                        totalBetAmt: nextProps.memberBettingHistoryData.data.data.bettingHistory.totalBetAmt,
                        totalPayoutAmt: nextProps.memberBettingHistoryData.data.data.bettingHistory.totalPayoutAmt,
                        totalWinLoseAmt: nextProps.memberBettingHistoryData.data.data.bettingHistory.totalWinLoseAmt,
                        totalTurnoverAmt: nextProps.memberBettingHistoryData.data.data.bettingHistory.totalTurnoverAmt,
                        totalRecords: nextProps.memberBettingHistoryData.data.data.bettingHistory.pagination.total_record,
                        totalPages: nextProps.memberBettingHistoryData.data.data.bettingHistory.pagination.total_page,
                        loading: false,
                    });
                }
                else {
                    this.setState({
                        show_id: null,
                        data: [],
                        subTotalBetAmt: 0,
                        subTotalPayoutAmt: 0,
                        subTotalWinLoseAmt: 0,
                        subTotalTurnoverAmt: 0,
                        totalBetAmt: 0,
                        totalPayoutAmt: 0,
                        totalWinLoseAmt: 0,
                        totalTurnoverAmt: 0,
                        totalRecords: 0,
                        totalPages: 1,
                        loading: false
                    }, () => {
                        filterErrorHandler(nextProps.memberBettingHistoryData.data.message);
                    })
                }
            }
            
        }

        // if (
        //     !nextState.reload &&
        //     nextProps.memberShowId !== undefined &&
        //     nextProps.memberBettingHistoryData !== undefined &&
        //     nextProps.memberBettingHistoryData !== this.props.memberBettingHistoryData
        // ) {
        //     if (nextProps.memberBettingHistoryData.status === 200 && nextProps.memberBettingHistoryData.data.msgType === "success") {
        //         this.setState({
        //             show_id: nextProps.memberShowId,
        //             data: nextProps.memberBettingHistoryData.data.data.bettingHistory.row,
        //             totalRecords: nextProps.memberBettingHistoryData.data.data.bettingHistory.pagination.total_record,
        //             totalPages: nextProps.memberBettingHistoryData.data.data.bettingHistory.pagination.total_page,
        //             loading: false,
        //         });
        //         Swal.close();
        //     } else {
        //         let msg = null;
        //         msg = "<ul>";
        //         nextProps.memberBettingHistoryData.message.forEach((val) => {
        //             msg += "<li>" + val + "</li>";
        //         });
        //         msg += "</ul>";

        //         Swal.fire({
        //             icon: "error",
        //             title: "error",
        //             html: msg,
        //             showConfirmButton: true,
        //         });
        //     }
        // } else if (
        //     nextState.reload &&
        //     nextProps.memberBettingHistoryData.data.data.bettingHistory.row !== nextState.data &&
        //     nextProps.memberBettingHistoryData !== undefined
        // ) {
        //     if (nextProps.memberBettingHistoryData.status === 200 && nextProps.memberBettingHistoryData.data.msgType === "success") {
        //         this.setState({
        //             show_id: nextProps.memberShowId,
        //             data: nextProps.memberBettingHistoryData.data.data.bettingHistory.row,
        //             totalRecords: nextProps.memberBettingHistoryData.data.data.bettingHistory.pagination.total_record,
        //             totalPages: nextProps.memberBettingHistoryData.data.data.bettingHistory.pagination.total_page,
        //             loading: false,
        //         });
        //         Swal.close();
        //     } else {
        //         let msg = null;
        //         msg = "<ul>";
        //         nextProps.memberBettingHistoryData.message.forEach((val) => {
        //             msg += "<li>" + val + "</li>";
        //         });
        //         msg += "</ul>";
        //         Swal.fire({
        //             icon: "error",
        //             title: "error",
        //             html: msg,
        //             showConfirmButton: true,
        //         });
        //     }
        // }

        if (nextProps.memberBettingHistoryFilterData !== undefined && nextState.dropDown.gameVendor.length === 0) {
            if(nextProps.memberBettingHistoryFilterData !== this.props.memberBettingHistoryFilterData) {
                if(nextProps.memberBettingHistoryFilterData.data.responseCode === 200 && nextProps.memberBettingHistoryFilterData.data.msgType === "success") {
                    this.setState({
                        dropDown: {
                            gameType: nextProps.memberBettingHistoryFilterData.data.data.gameType,
                            gameVendor: nextProps.memberBettingHistoryFilterData.data.data.gameVendor
                        },
                    });
                    //Swal.close();
                } else {
                    filterErrorHandler(nextProps.memberBettingHistoryFilterData.data.message);
                }  
            }
        }
        return true;
    }

    componentWillUnmount() {
        // console.log("[MemberBettingHistory] componentWillUnmount()", "\nstate: ", this.state);
        this.props.setMemberShowLocalState(this.state);
    }

    onInputChange(event) {
        // console.log(event.target.id+' | '+event.target.value);
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;
        if (event.target.id === "transaction_date") {
            const date = event.target.value !== "" ? event.target.value.split(" - ") : null;
            newFilter["start_date"] = date ? date[0] : "";
            newFilter["end_date"] = date ? date[1] : "";
        }
        this.setState({
            filter: newFilter,
        });
    }

    refreshHandler = () => {
        this.setState(
            {
                loading: true,
                data: [],
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                order: ""
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.getMemberBettingHistory(listingArr);
            }
        );
    };

    clearHandler = () => {
        let newFilter = initialInputState;
        this.setState(
            {
                activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
                limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
                searchValue: "",
                filter: newFilter,
                loading: true,
                data: [],
                order: ""
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.getMemberBettingHistory(listingArr);
            }
        );
    };

    getFilterArray = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;

        listingArr.member_id = this.props.memberShowId;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        listingArr.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);
        // listingArr.country_id = this.props.currentCountryId;
        listingArr.language = this.props.currentLanguage;
        Object.keys(this.state.filter).forEach((val) =>
        {
            listingArr[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });
        return listingArr;
    };

    changePageHandler = (page) => {
        // console.log(page);
        this.setState({
            pageShow: page,
        });
    };
    /* ============ function [END] ============ */

    /* ============ datatables function [START] ============ */
    datatablesChangeHandler = (val, act) => {
        this.setState(
            {
                [act]: act === "searchValue" ? val.target.value : val,
                loading: true,
                data: [],
            },
            () => {
                const listingArr = this.getFilterArray();
                this.props.getMemberBettingHistory(listingArr);
            }
        );
    };

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = order === "asc" ? true : false;

        orderArry[0]["id"] = field;
        orderArry[0]["desc"] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: [],
            // errMsg: [],
            // touched: false,
        }, () => {
            const listingArr = this.getFilterArray();
            this.props.getMemberBettingHistory(listingArr);
        });
    };

    render() {
        // const { t } = this.props;
        return (
            <Auxiliary>
                {this.state.pageShow === "member_betting_listing" && (
                    <MemberBettingHistoryListing
                        filter={this.state.filter}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        searchHandler={() => this.refreshHandler()}
                        clearHandler={() => this.clearHandler()}
                        refreshHandler={() => this.refreshHandler()}
                        onInputChange={(event) => this.onInputChange(event)}
                        datatablesChangeHandler={(val, act) => this.datatablesChangeHandler(val, act)}
                        onSort={(field, order) => this.onSort(field, order)}
                        data={this.state.data}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        searchValue={this.state.searchValue}
                        ddGameVendor={this.state.dropDown.gameVendor}
                        ddGameType={this.state.dropDown.gameType}
                        loading={this.state.loading}
                        subTotalBetAmt={this.state.subTotalBetAmt}
                        subTotalPayoutAmt={this.state.subTotalPayoutAmt}
                        subTotalWinLoseAmt={this.state.subTotalWinLoseAmt}
                        subTotalTurnoverAmt={this.state.subTotalTurnoverAmt}
                        totalBetAmt={this.state.totalBetAmt}
                        totalPayoutAmt={this.state.totalPayoutAmt}
                        totalWinLoseAmt={this.state.totalWinLoseAmt}
                        totalTurnoverAmt={this.state.totalTurnoverAmt}
                        memberCurrency={this.props.memberCurrency}
                    />
                )}
            </Auxiliary>
        );
    }
}

const mapStateToProps = (state) => {
    const { member } = state;

    return {
        memberShowInitialLoading: member.member_show_initial_loading,
        memberBettingHistoryLocalState: member.member_betting_history_local_state,

        memberBettingHistoryData: member.member_betting_history_data,
        memberBettingHistoryFilterData: member.member_betting_history_filter_data,
        currentCountryId: state.currentUser.data.country_id,
        currentLanguage: state.currentUser.data.language_code
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMemberShowLocalState: (data) => dispatch(setMemberShowLocalState(data)),
        setMemberShowInitialLoading: (data) => dispatch(setMemberShowInitialLoading(data)),

        getMemberBettingHistory: (data) => dispatch(getMemberBettingHistory(data)),
        getBettingHistoryFilterData: () => dispatch(getBettingHistoryFilterData()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MemberBettingHistory));
